import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 */
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="38k6wetfvdtlx" />} data-id="element-0" data-mp="38kqau06b9zv7">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-ivory text-charcoal" data-id="element-2" data-mp="nw2cw89b1us5">
      <Hero data-id="element-3" data-mp="nxn5vtfz15nw" />
      <Deferred minHeight="460px" data-id="element-4" data-mp="nxwvhfx3tat2">
        <PainSection data-id="element-5" data-mp="stuexv3nyxa2" />
      </Deferred>
      <Deferred minHeight="820px" background="bg-sand" data-id="element-6" data-mp="sssqmoxn0eae">
        <TomosSection data-id="element-7" data-mp="35oymvdpbcv8" />
      </Deferred>
      <Deferred minHeight="520px" data-id="element-8" data-mp="34napqbl6vw3">
        <BonosSection data-id="element-9" data-mp="3uct0lbuzo8ws" />
      </Deferred>
      <Deferred minHeight="440px" background="bg-sand" data-id="element-10" data-mp="3ubriwojgwo63">
        <OfferSection data-id="element-11" data-mp="d4nuteha5g1c" />
      </Deferred>
      <Deferred minHeight="380px" data-id="element-12" data-mp="d3mil6oj2ni1">
        <TestimonialsSection data-id="element-13" data-mp="d2l7x3bfc30u" />
      </Deferred>
      <Deferred minHeight="240px" background="bg-sand" data-id="element-14" data-mp="85bap1hsmn2g">
        <GuaranteeSection data-id="element-15" data-mp="83qgjcze5654" />
      </Deferred>
      <Deferred minHeight="420px" data-id="element-16" data-mp="3gklc07duzo96">
        <FaqSection data-id="element-17" data-mp="3glo0k8nplelx" />
      </Deferred>
      <Deferred minHeight="380px" background="bg-sand" data-id="element-18" data-mp="3bmjqlfsyncuj">
        <FinalCta data-id="element-19" data-mp="3bo4mb8r0h1tz" />
      </Deferred>
      <Deferred minHeight="380px" background="bg-sand" data-id="element-20" data-mp="3qb7jfebf98gs">
        <Footer data-id="element-21" data-mp="3qcqy50hfjbgg" />
      </Deferred>
      <Suspense fallback={null} data-id="element-22" data-mp="3lkheg26wr7mm">
        <StickyBuyBar data-id="element-23" data-mp="3lk7ky4mnmic6" />
      </Suspense>
    </main>;
}